/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import Image from 'next/image';
import Link from 'next/link';

const CategoryItem = ({ category }) => {
  const linkBaseUrl = '/brands/categories/detail';

  return (
    <Link href={`${linkBaseUrl}/[id]`} as={`${linkBaseUrl}/${category.id}`}>
      <div className="col-15 col-md-5 col-lg-3 mb-20">
        <a className="brand-card">
          <div className="mb-20">
            <Image
              src={`/image/categories/${category.id}.jpg`}
              width="200"
              height="200"
              layout="responsive"
            />
          </div>
          <span className="brand-card-title">{category.title}</span>
        </a>
      </div>
    </Link>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.object,
};

export default CategoryItem;
